import { Box, Button, TextField, MenuItem, Select,Switch, FormControlLabel, IconButton, Menu } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { menuActive } from '../../store/menuSlice'
import { useNavigate } from 'react-router-dom'
import styles from './healthAss.module.css'
import * as api from '../services/api'
import Loader from '../../components/Loader';
import Record from '../../assets/icons/assessment/record.svg'
import { styled } from '@mui/material/styles';
import MoreVertIcon from '@mui/icons-material/MoreVert'; 
import ModalExportAssessment from 'components/modal/ModalExportAssessment'

function ManageAssessment() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState('')
    const [month, setMonth] = useState('')
    const [category, setCategory] = useState('')
    const [courseList, setcourseList] = useState([])
    const [optionGroup, setOptionGroup] = useState([])
    const [record, setRecord] = useState({});
    const [toggles, setToggles] = useState([]);
    const [menuData, setMenuData] = useState({ anchorEl: null, form: null });
    const [openModalExport, setOpenModalExport] = useState(false)
    const [evaluation_code, setEvaluation_code] = useState('');

    const handleMenuClick = (event, form) => {
        setMenuData({ anchorEl: event.currentTarget, form });
    };
    
    const handleMenuClose = () => {
        setMenuData({ anchorEl: null, form: null });
    };

    const handleEdit = () => {
        if (menuData.form) {
            navigate('/editAssessment', { state: { formCode: menuData.form['evaluation_code'] } });
        }
        handleMenuClose();
    };

    const handleExport = async (menuData) => {
        setEvaluation_code(menuData.form['evaluation_code']);
        setOpenModalExport(true)
        handleMenuClose();
    };
    
    const handleToggle = async (code,index) => {
        setLoading(true);
        let res = await api.activateEvaluation(code);
        setLoading(false);
        if (res) {
          if (res['data']['code'] === 200) {
            // return;
          } else {
              //alert(res['data']['message']);
          }
        } else {
          alert('ไม่ตอบสนอง');
        }

    setToggles((prevToggles) => {
    const newToggles = [...prevToggles];
    const currentStatus = newToggles[index];

    newToggles[index] = currentStatus === "Active" ? "Inactive" : "Active";
  
      return newToggles; 
    });

      };

    const handleChange = (type, e) => {

        if (type === 'month') {
          setMonth(e.target.value)
          // setErrorMessage('')
    
        } else if (type === 'category') {
          setCategory(e.target.value)
          // setErrorMessage('')
        }
    }

    const fetchFormEvaluation = async (searchQuery, doc_status_name) => {
        setLoading(true);
        const res = await api.findFormEvaluation(searchQuery, doc_status_name);
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                const detail = res['data']['data'];
                setcourseList(detail);
                setToggles(detail.map(item => item.doc_status_name))
            } else {
                //alert(res['data']['message']);
            }
        } else {
          alert("ไม่ตอบสนอง");
        }
    } 

    const fetchOption = async () => {
        setLoading(true);
        const res = await api.dropdownFormEvaluationStatus();
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                const detail = res['data']['data'];
                const simplifiedOptions = detail.map(item => ({ key: item.name, value: item.name }));
                setOptionGroup(simplifiedOptions);
            } else {
                //alert(res['data']['message']);
            }
        } else {
          alert("ไม่ตอบสนอง");
        }
    }   
    
    const handleFilterGroup = (e) => {
        const selectedCategory = e.target.value;
        setCategory(selectedCategory);    
        if (selectedCategory === "null") {
            fetchFormEvaluation(search, null);
        } else {
            fetchFormEvaluation(search,selectedCategory );
        }
    };

    const fetchRecord = async (department,year) => {
        setLoading(true);
        const res = await api.getOverallEvaluation(department,year);
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                // const detail = res['data']['data']['summary']['evaluation_record'];
                // setRecord(detail.map(item => item.total_evaluation_record));
                const detail = res['data']['data']['summary']['evaluation_record'];

                // Create an object: { [evaluation_code]: total_evaluation_record }
                const evaluationMap = {};
                detail.forEach(item => {
                evaluationMap[item.evaluation_code] = item.total_evaluation_record;
                });
                setRecord(evaluationMap);
            } else {
                //alert(res['data']['message']);
            }
        } else {
          alert("ไม่ตอบสนอง");
        }
    }

    useEffect(() => {
        // dispatch(menuActive('แบบประเมินสุขภาพ'))
        // dispatch(menuActive('แบบประเมินทั้งหมด'))
        dispatch(menuActive('จัดการแบบประเมิน'))
        fetchFormEvaluation("", null);
        fetchOption();
        fetchRecord();
    }, [])

    // const handleClickOpen = (e) => {
    //     navigate(e.path)
    // }

    const handleClickSearch = () => {
        fetchFormEvaluation(search)
    }

    return (
        <>
        <Loader loading={loading} />
            {openModalExport ?
                <ModalExportAssessment
                    onClose={() => { setOpenModalExport(false) }}
                    evaluation_code={evaluation_code}
                />
                : null
            }    
            
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>จัดการแบบประเมิน</Box>
                <Box sx={{fontSize: 14}}>สร้างแบบประเมินสุขภาพสำหรับกำลังพล สป.</Box>
                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    display: 'flex',
                    padding: '5px'
                }}>
                    <TextField
                        fullWidth
                        variant="standard"
                        sx={{
                            ...InputCSS
                        }}
                        InputProps={{
                            disableUnderline: true,
                        }}
                        placeholder="พิมพ์ข้อความเพื่อค้นหาข้อมูล..."
                        value={search}
                        onChange={(e) => { setSearch(e.target.value) }}
                    />
                    <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
                </Box>
                
                <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    "@media (max-width: 800px)": {
                      display: 'grid',
                      gridGap: '10px',
                    },
                  }}
                >
                {/* <Box>
                <Select
                    size="small"
                    value={category || "null"}
                    onChange={(e) => {
                        handleChange('category', e);
                    }}
                    sx={{
                        backgroundColor: '#C8EBEB',
                        border: 'none',
                        '.MuiOutlinedInput-notchedOutline': {
                        borderColor: '#C8EBEB',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#C8EBEB',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#C8EBEB',
                        },
                        minWidth: '130px',
                        height: '50px',
                        borderRadius: '10px',
                        marginRight: '10px'
                    }}
                    >
                    <MenuItem value="null" disabled>
                        เลือกหมวดหมู่
                    </MenuItem>
                    {monthList.map((d, idx) => (
                        <MenuItem key={idx} value={d['id']}>
                        {d['name']}
                        </MenuItem>
                    ))}
                    </Select>

                    <Select
                    size="small"
                    value={month || "null"}
                    onChange={(e) => {
                        handleChange('month', e);
                    }}
                    sx={{
                        backgroundColor: '#C8EBEB',
                        border: 'none',
                        '.MuiOutlinedInput-notchedOutline': {
                        borderColor: '#C8EBEB',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#C8EBEB',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#C8EBEB',
                        },
                        minWidth: '130px',
                        height: '50px',
                        borderRadius: '10px'
                    }}
                    >
                    <MenuItem value="null" disabled>
                        เลือกเดือน
                    </MenuItem>
                    {monthList.map((d, idx) => (
                        <MenuItem key={idx} value={d['id']}>
                        {d['name']}
                        </MenuItem>
                    ))}
                    </Select>
                </Box> */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Select
                    size="small"
                    sx={{ ...SelectCss }}
                    value={category || "null"}
                    onChange={(e) => { handleFilterGroup(e) }}
                    >
                    <MenuItem value="null">เลือกสถานะ</MenuItem>
                    {optionGroup.map((i, idx) => (
                        <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
                    ))}
                    </Select>
                </Box>

                <Button
                    variant="contained"
                    sx={{
                    backgroundColor: '#478F96',
                    borderRadius: '10px',
                    height: '50px',
                    // fontWeight: 600,
                    width: '130px',
                    }}
                    onClick={() => navigate('/addAssessment')}
                >
                    เพิ่มแบบประเมิน
                </Button>
                </Box>


                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gridGap: '10px',
                    "@media (max-width: 1000px)": {
                        gridTemplateColumns: '1fr 1fr',
                    },
                    "@media (max-width: 600px)": {
                        gridTemplateColumns: '1fr',
                    }
                }}>
                    {courseList.map((form, index) => (
                        <Box sx={{
                            border: '1px solid #2F327D1A',
                            boxShadow: '2px 2px 10px #2F327D1A',
                            backgroundColor: '#ffffff',
                            borderRadius: '10px',
                            padding: '15px',
                            // cursor: 'pointer',
                            height: '420px'
                        }}
                            key={index}
                        >
                            <Box sx={{ display:'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%'}}>
                                <Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        <Box className={styles.container} sx={{ marginBottom: '5px' }}>
                                            <img src={form['evaluation_image']} className={styles.img} />
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <img src={Record} width={20} alt="Record" />
                                            <Box sx={{ fontWeight: 500, color: '#696984', fontSize: '12px' }}>
                                            ประเมินแล้ว {form['evaluation_data_total']?form['evaluation_data_total']:0} คน
                                            </Box>
                                        </Box>

                                        <Box sx={{ 
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2, // Number of lines to show
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontWeight: 600, 
                                            color: '#252641',
                                            fontSize: '14px' }}>
                                            {form['evaluation_name']}
                                        </Box>

                                        <Box
                                        sx={{
                                            display: '-webkit-box',
                                            WebkitLineClamp: 3, // Number of lines to show
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            color: '#696984',
                                            fontSize: '14px',
                                        }}
                                        >
                                        {form['evaluation_detail']}
                                        </Box>
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <FormControlLabel
                                        control={<IOSSwitch />}
                                        checked={toggles[index] === "Active"}
                                        onChange={() => handleToggle(form['evaluation_code'], index)}
                                    />
                                    <Box sx={{ width: '1.3px', height: '18px', backgroundColor: '#ccc' , marginRight: '5px'}} /> 
                                    <IconButton onClick={(event) => handleMenuClick(event, form)}>
                                        <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                        anchorEl={menuData.anchorEl}
                                        open={Boolean(menuData.anchorEl)}
                                        onClose={handleMenuClose}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                    >
                                        {menuData.form && menuData.form['evaluation_code'] !== 'EVA-F-0001' && menuData.form['evaluation_code'] !== 'EVA-F-0002' && (
                                            <MenuItem onClick={() => handleEdit()}>แก้ไข</MenuItem>
                                        )}
                                        <MenuItem onClick={() => handleExport(menuData)}>Export ข้อมูล</MenuItem>
                                    </Menu>
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </>
    )
}

export default ManageAssessment

const InputCSS = {
    padding: '5px',
    border: 'none',
    '&.MuiInputBase-root': {
        border: 'none'
    },
    '&.MuiInputBase-root:focus': {

    }
}

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#478F96',
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#C8EBEB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#C8EBEB',
    },
  }
